<template>
  <div>
    <!-- 景区设置 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/worke' }">位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>景区设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tabCss">
      <span
        v-for="(v, i) in tabTitle"
        :key="i"
        v-if="v.id !== 5 || ScenicId == 185"
        :class="typeTab == v.id ? 'active' : ''"
        @click="tabFn(v.id)"
        >{{ v.name }}</span
      >
    </div>
    <div class="contentBox" v-if="typeTab == 1">
      <div class="conOne">
        <div class="conRight">
          <div>
            <span>基本信息</span>
            <span class="setCur" @click="infoSetFn(infor)">设置></span>
          </div>
          <el-divider></el-divider>
          <div>
            <el-descriptions :column="1" direction="vertical" :colon="false">
              <el-descriptions-item label="简称">{{
                infor.Name
              }}</el-descriptions-item>
              <el-descriptions-item label="全称">{{
                infor.FullName
              }}</el-descriptions-item>
              <el-descriptions-item label="联系人"
                >{{ infor.LinkMan }}</el-descriptions-item
              >
              <el-descriptions-item label="联系电话">{{
                infor.Phone
              }}</el-descriptions-item>
              <el-descriptions-item label="Email">{{
                infor.E_Mail
              }}</el-descriptions-item>
              <el-descriptions-item label="景区详细地址">{{
                infor.Address
              }}</el-descriptions-item>
              <el-descriptions-item label="经纬度">
                <div>经度:{{ infor.lon }}</div>
                <div>纬度:{{ infor.lat }}</div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <div class="conCenter">
          <div class="conCenterTop">
            <div>
              <span>短信设置</span>
              <span class="setCur" @click="noteSetFn()">设置></span>
            </div>
            <el-divider></el-divider>
            <div>
              <span>系统短信余额:</span>
              <span>{{ infor.Balance }}</span>
              <span>元</span>
            </div>
            <div>
              <div>
                <span>短息模板</span>
                <span>(使用中)</span>
              </div>
              <div>{{ infor.ExamineSms }}</div>
            </div>
          </div>
          <div class="conCenterBottom">
            <div>
              <span>群发短信</span>
              <!-- <span class="setCur">设置></span> -->
            </div>
            <el-divider></el-divider>
            <div>
              <span>本月剩余次数</span>
              <span>{{ num }}</span>
              <span>次</span>
            </div>
            <div>
              <el-button @click="editSend">去编辑发送</el-button>
            </div>
          </div>
        </div>
        <div class="calendarData">
          <div>
            <div class="dataC" style="width: 95%">
              <a-calendar
                :fullscreen="false"
                :header-render="headerRender"
                @panelChange="onPanelChange"
              />
            </div>
            <div class="dataC" style="width: 95%">
              <a-calendar
                :fullscreen="false"
                :header-render="headerRender"
                @panelChange="onPanelChange"
              />
            </div>
          </div>
          <div>
            <div>
              <span>最近节假日</span>
              <!-- @click="fivstFn" -->
              <span class="setCur">设置></span>
            </div>
            <el-divider></el-divider>
            <div>
              <div class="festival">
                <div>清明节</div>
                <div>
                  <span>开始时间:</span>
                  <span>1546542</span>
                  <span>结束时间:</span>
                  <span>1546542</span>
                </div>
                <img class="img" src="@/images/scenic/jjr.png" alt />
              </div>
              <div class="festival">
                <div>五一劳动节</div>
                <div>
                  <span>开始时间:</span>
                  <span>1546542</span>
                  <span>结束时间:</span>
                  <span>1546542</span>
                </div>
                <div class="btn">
                  <el-button type="text">编辑</el-button>
                  <el-button class="btnL" type="text">删除</el-button>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="conTwo">
        <!-- <div>
          <div style="cursor: pointer;" @click="wxOfficalFn">微信公众号设置</div>
          <el-divider></el-divider>
          <div>是否启用微信公众号设置(ps:如果要开启,保存后生效)</div>
          <div>微信公众平台服务器配置信息(配置成功后不可修改)</div>
          <div>
            <el-switch v-model="value" active-color="#246DEB" inactive-color="#E5E5EA"></el-switch>
          </div>
          <div>
            <el-descriptions :column="1" direction="vertical" :colon="false">
              <el-descriptions-item label="公众号名称">kooriookami</el-descriptions-item>
              <el-descriptions-item label="公众号原始id">{{infor.wxid}}</el-descriptions-item>
              <el-descriptions-item label="微信号">苏州市</el-descriptions-item>
              <el-descriptions-item label="AppID(公众号)">{{infor.qiyue_appid}}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div> -->
        <div class="conTwoRight">
          <div>
            <div>接口设置</div>
            <el-divider></el-divider>
            <div>
              <div>
                <el-button
                  type="primary"
                  plain
                  @click="interFn(item)"
                  v-for="(item, index) in interface"
                  :key="index"
                  >{{ item.apiname }}</el-button
                >
                <!-- <el-button type="primary" plain @click="interFn()">应用名称2</el-button> -->
              </div>
              <div class="add_axios">
                <el-button type="primary" @click="addInter"
                  >添加应用接口</el-button
                >
              </div>
            </div>
          </div>
          <div>
            <div>
              <span>退款短信设置</span>
              <span class="setCur" @click="TuiSetFn">设置></span>
            </div>
            <div class="muban">
              <div>
                <span>退款模板</span>
                <span>(使用中)</span>
              </div>
            </div>
          </div>
          <!-- <div>
            <div>
              <span>结算设置</span>
              <span class="setCur" @click="maySetFn">设置></span>
            </div>
            <el-divider></el-divider>
            <div class="formBuy">
              <el-form ref="form" :model="form" label-width="130px">
                <div class="itemOne">
                  <div>
                    <el-form-item label="结算周期不能低于:">
                      <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <span>天</span>
                  </div>
                  <div>
                    <el-form-item label="结算金额不能低于:">
                      <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <span>元</span>
                  </div>
                  <div>
                    <el-form-item label="销售方名称:">
                      <el-input v-model="form.name" placeholder="--"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="itemTwo">
                  <el-form-item label="开户名称:">
                    <el-input v-model="form.name" placeholder="--"></el-input>
                  </el-form-item>
                  <el-form-item label="开户行:">
                    <el-input v-model="form.name" placeholder="--"></el-input>
                  </el-form-item>
                  <el-form-item label="结算联系人姓名:">
                    <el-input v-model="form.name" placeholder="--"></el-input>
                  </el-form-item>
                  <el-form-item label="结算联系人手机号:">
                    <el-input v-model="form.name" placeholder="--"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <el-card v-if="typeTab == 2">
      <div class="searRow">
        <div class="searLeft">
          <el-input placeholder="电话号码" v-model="data2.mobile"></el-input>
          <el-input placeholder="身份证" v-model="data2.idcard"></el-input>
          <div class="searLeftSel">
            <el-select v-model="data2.type" placeholder="请选择类型" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="query">查询</el-button>
        </div>
        <div class="searRight">
            <div @click="exportList">
              <img src="@/images/export.png" alt="">
              <span> 导出 </span>
            </div>
            <div @click="addblacklist">
              <img src="@/images/add.png" alt="">
              <span>增加</span>
            </div>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column
            label="编号"
            prop="id"
            type="index"
          ></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="idcard" label="身份证"></el-table-column>
          <el-table-column prop="created_at" label="添加时间"></el-table-column>
          <el-table-column prop="user_name" label="添加人"></el-table-column>
          <el-table-column label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="color: #ff4d4f"
                @click="dete(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{ data2.total }}条记录，</span>
        <span class="demonstration">当前显示第{{ data2.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="data2.total"
          @current-change="blackListPage"
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-card class="conentBox" v-if="typeTab == 3">
      <div class="searRow">
        <div class="searLeft">
          <el-button type="primary" @click="addPeanut">添加</el-button>
        </div>
      </div>
      <div>
        <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column prop="hotelname" label="名称" ></el-table-column>
        <el-table-column prop="url" label="回调本地地址"></el-table-column>
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="pwd" label="密码"></el-table-column>
        <el-table-column  label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="addProFn(scope.row)">详情</el-button>
            <el-button type="text" @click="detelePro(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
    
    </el-card>
    <el-card class="conentBox" v-if="typeTab == 4">
      <div class="content_box_back">
        <el-form :model="ruleForm"  label-width="140px" ref="ruleForm" :label-position="labelPosition" class="demo-ruleForm">
          <el-form-item label="支付类型:" >
            <el-radio-group v-model="ruleForm.pay_type">
              <el-radio label="1">微信</el-radio>
              <el-radio label="2">支付宝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="微信公众号appid:" v-if="ruleForm.pay_type=='1'">
            <el-input v-model="ruleForm.wx_appid" placeholder="请输入微信公众号appid"></el-input>
          </el-form-item>
          <el-form-item label="微信公众号密钥:" v-if="ruleForm.pay_type=='1'">
            <el-input v-model="ruleForm.wx_secret" placeholder="请输入微信公众号密钥"></el-input>
          </el-form-item>
          <el-form-item label="微信商户号:" v-if="ruleForm.pay_type=='1'">
            <el-input v-model="ruleForm.wx_mchid" placeholder="请输入微信商户号"></el-input>
          </el-form-item>
          <el-form-item label="微信支付密钥:" v-if="ruleForm.pay_type=='1'">
            <el-input v-model="ruleForm.wx_mchkey" placeholder="请输入微信支付密钥"></el-input>
          </el-form-item>
          <el-form-item label="支付宝商户appid:" v-if="ruleForm.pay_type=='2'">
            <el-input v-model="ruleForm.ali_appid" placeholder="请输入支付宝商户appid"></el-input>
          </el-form-item>
          <el-form-item label="支付宝公钥:" v-if="ruleForm.pay_type=='2'">
            <el-input v-model="ruleForm.ali_public_key" placeholder="请输入支付宝公钥"></el-input>
          </el-form-item>
          <el-form-item label="支付宝私钥:" v-if="ruleForm.pay_type=='2'">
            <el-input v-model="ruleForm.ali_rivate_key" placeholder="请输入支付宝私钥"></el-input>
          </el-form-item>
        </el-form>
        <div class="btns_wx_zfb">
          <div @click="submitbtn">
            提交
          </div>
        </div>
      </div>
    
    </el-card>

    <el-card class="conentBox" v-if="typeTab == 5">
      <div class="content_box_back" style="display: flex;">
        <div>
          <el-date-picker
            v-model="supplementaryPassDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="searRow" style="margin-left: 30px;">
          <el-button type="primary" @click="onUpload" :loading="uploadLoading">上传</el-button>
        </div>
      </div>
    </el-card>
    <!-- 节日设置弹框开始 -->
    <scenicSetDialog v-if="fivstvisible" ref="fivstDialog"></scenicSetDialog>
    <!-- 节日设置弹框结束 -->
    <!-- 短信设置弹框开始 -->
    <scenicSetDialog
      v-if="notevisible"
      ref="noteDialog"
      @ScenicNot="ScenicNot"
    ></scenicSetDialog>
    <!-- 短信设置弹框结束 -->
    <!-- 基本信息设置弹框开始 -->
    <scenicSetDialog
      v-if="infovisible"
      ref="infoDialog"
      @scenic="setClose"
    ></scenicSetDialog>
    <!-- 基本信息弹框结束 -->
    <!-- 去编辑发送群发消息弹框开始 -->
    <scenicSetDialog
      v-if="editSendvisible"
      ref="editSendDialog"
      @massMsg="massMsgClose"
    ></scenicSetDialog>
    <!-- 去编辑发送群发消息弹框结束 -->
    <!-- 微信公众号设置弹框开始 -->
    <scenicSetBoDialog
      v-if="wxofficalvisible"
      ref="wxofficalDialog"
    ></scenicSetBoDialog>
    <!-- 微信公众号设置弹框结束 -->
    <!-- 应用接口弹框开始 -->
    <scenicSetBoDialog
      v-if="intervisible"
      ref="interDialog"
      @interClose="interClose"
    ></scenicSetBoDialog>
    <!-- 应用接口弹框结束 -->
    <!-- 添加应用接口弹框开始 -->
    <scenicSetBoDialog
      v-if="estintervisible"
      ref="estinterDialog"
      @clos="estinClose"
    ></scenicSetBoDialog>
    <!-- 添加应用接口弹框结束 -->
    <!-- 结算设置弹框开始 -->
    <scenicSetBoDialog
      v-if="maySetvisible"
      ref="maySetDialog"
    ></scenicSetBoDialog>
    <!-- 结算设置弹框结束 -->
    <el-dialog :close-on-click-modal="false"
      title="添加"
      :visible.sync="blacklist"
      :before-close="mobileHandleClose"
      width="24.0%"
      center
      top="30vh"
    >
      <el-form ref="form" :model="formblack" label-width="85px">
        <div class="formItem">
          <el-form-item label="电话号:">
            <el-input
              v-model="formblack.mobile"
              placeholder="电话号"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证:">
            <el-input
              v-model="formblack.idcard"
              placeholder="身份证"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="flexbtnL">
        <el-button class="btnL" type="primary" @click="increase"
          >确认保存</el-button
        >
      </div>
    </el-dialog>
    <tuikuan    v-if="tuikuanvisible"
      ref="tuikuanDialog"
      @clos="tuikuanClose"></tuikuan>


    <el-dialog :close-on-click-modal="false"
      title="添加"
      :visible.sync="peanutFlow"
      :before-close="PeanuHandleClose"
      width="24.0%"
      center
      top="30vh"
    >
      <el-form ref="form" :model="peanut" label-width="85px">
        <div class="formItem">
          <el-form-item label="名称:">
            <el-input
              v-model="peanut.hotelname"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="回调地址:">
            <el-input
              v-model="peanut.url"
              placeholder="请输入回调地址"
              @input="chage($event)"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名:">
            <el-input
              v-model="peanut.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码:">
            <el-input
              v-model="peanut.pwd"
              type="password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="flexbtnL">
        <el-button class="btnL" type="primary" 
           @click="btnsQuer">确认保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import scenicSetDialog from "./dialog/scenicSetDialog.vue";
import scenicSetBoDialog from "./dialog/scenicSetBoDialog.vue";
import tuikuan from "./dialog/tuikuan.vue";

import {
  ScenicMessage,
  ScenicPortList,
  deleteBlackList,
  getBlackList,
  exportBlackList,
  addBlackList,
  QFSMS,
  GetOuterNetAnalysis,
  OuterNetAnalysisAdd,
  SetOuterNetAnalysis,
  DelOuterNetAnalysis , 
  addScenicPayInfo,
  scenicPayInfo,
  peopleFlowByDate
} from "@/request/scenic.js";
import { MessageBox,Message} from "element-ui";
export default {
  components: {
    scenicSetDialog,
    scenicSetBoDialog,
    tuikuan
  },
  data() {
    return {
      labelPosition: 'right',
      ruleForm:{
        token: window.sessionStorage.getItem("Token"),
        pay_type:'1',
        wx_appid:'',
        wx_secret:'',
        wx_mchid:'',
        wx_mchkey:'',
        ali_appid:'',
        ali_public_key:'',
        ali_rivate_key:''
      },
      tuikuanvisible:false,
      tableData: [
        {
          name: "高怡静",
          mobile: "17636000478",
          idcard: "14276216+161561561",
          id: 1,
        },
        {
          name: "高怡静",
          mobile: "17636000478",
          idcard: "14276216+161561561",
          id: 2,
        },
        {
          name: "高怡静",
          mobile: "17636000478",
          idcard: "14276216+161561561",
          id: 3,
        },
        {
          name: "高怡静",
          mobile: "17636000478",
          idcard: "14276216+161561561",
          id: 4,
        },
        {
          name: "高怡静",
          mobile: "17636000478",
          idcard: "14276216+161561561",
          id: 5,
        },
      ],
      typeTab: "1",
      tabTitle: [
        {
          id: 1,
          name: "基本信息",
        },
        {
          id: 2,
          name: "黑名单",
        },
        {
          id: 3,
          name: "花生壳回调",
        },
        {
          id: 4,
          name: "支付信息配置",
        },
        {
          id: 5,
          name: "日客流量补传",
        }
      ],
      num: 5,
      fivstvisible: false, // 节日设置弹框
      notevisible: false, // 短信设置弹框
      infovisible: false, // 基本信息弹框
      editSendvisible: false, // 去编辑发送群发消息
      wxofficalvisible: false, // 微信公众号
      intervisible: false, // 应用接口
      estintervisible: false, // 添加应用接口
      maySetvisible: false, // 结算设置
      value: true,
      form: {
        name: "",
      },
      data: {
        token: window.sessionStorage.getItem("Token"),
      },
      infor: "",
      interface: "",
      options: [
        {
          label: "手机号",
          value: "1",
        },
        {
          label: "身份证",
          value: "2",
        },
        {
          label: "全部",
          value: "3",
        },
      ],
      data2: {
        token: window.sessionStorage.getItem("Token"),
        page: 1,
        page_size: 10,
        mobile: "",
        total: 0,
        idcard: "",
        type: "3",
      },
      blacklist: false,
      formblack: {
        token: window.sessionStorage.getItem("Token"),
        mobile: "",
        idcard: "",
      },
      huashengData:[],
      peanutFlow:false,
      peanut:{
        token: window.sessionStorage.getItem("Token"),
        username:'',
        hotelname:'',
        pwd:'',
        url:'',
        id:''
      },
      supplementaryPassDate: '',
      uploadLoading: false
    };
  },
  created() {
    this.information();
    this.getpost();
    this.getMsm();
    this.ScenicId = sessionStorage.getItem("ScenicId");
  },
  methods: {
    getPayInfo(){
      let data = {
        token: window.sessionStorage.getItem("Token"),
      }
      scenicPayInfo(data).then(res=>{
        if(res.data.rcode==200){
          this.ruleForm = {
            token: window.sessionStorage.getItem("Token"),
            pay_type:'1',
            wx_appid:res.data.result.wxInfo.wx_appid,
            wx_secret:res.data.result.wxInfo.wx_secret,
            wx_mchid:res.data.result.wxInfo.wx_mchid,
            wx_mchkey:res.data.result.wxInfo.wx_mchkey,
            ali_appid:res.data.result.aliInfo.ali_appid,
            ali_public_key:res.data.result.aliInfo.ali_public_key,
            ali_rivate_key:res.data.result.aliInfo.ali_rivate_key
          }
        }
      })
    },
    submitbtn(){
      let data = {}
      if(this.ruleForm.pay_type=='1'){
        if(this.ruleForm.wx_appid==''){
          this.$message.error('请输入微信公众号appid')
          return false
        }
        if(this.ruleForm.wx_secret==''){
          this.$message.error('请输入微信公众号密钥')
          return false
        }
        if(this.ruleForm.wx_mchid==''){
          this.$message.error('请输入微信商户号 ')
          return false
        }
        if(this.ruleForm.wx_mchkey==''){
          this.$message.error('请输入微信支付密钥')
          return false
        }
      }else{
        if(this.ruleForm.ali_appid==''){
          this.$message.error('请输入支付宝商户appid')
          return false
        }
        if(this.ruleForm.ali_public_key==''){
          this.$message.error('请输入支付宝公钥 ')
          return false
        }
        if(this.ruleForm.ali_rivate_key==''){
          this.$message.error('请输入支付宝私钥')
          return false
        }
      }
      data = {
        token: window.sessionStorage.getItem("Token"),
        pay_type:this.ruleForm.pay_type,
        wx_appid:this.ruleForm.pay_type=='1'?this.ruleForm.wx_appid:'',
        wx_secret:this.ruleForm.pay_type=='1'?this.ruleForm.wx_secret:'',
        wx_mchid:this.ruleForm.pay_type=='1'?this.ruleForm.wx_mchid:'',
        wx_mchkey:this.ruleForm.pay_type=='1'?this.ruleForm.wx_mchkey:'',
        ali_appid:this.ruleForm.pay_type=='2'?this.ruleForm.ali_appid:'',
        ali_public_key:this.ruleForm.pay_type=='2'?this.ruleForm.ali_public_key:'',
        ali_rivate_key:this.ruleForm.pay_type=='2'?this.ruleForm.ali_rivate_key:'',
      }
      addScenicPayInfo(data).then(res=>{
        if(res.data.rcode==200){
          this.$message.success('添加支付信息成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    detelePro(row){
      let data = {
        token: window.sessionStorage.getItem("Token"),
        id:row.id
      }
      MessageBox("此操作将删除该地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelOuterNetAnalysis(data).then(res=>{
            if(res.data.rcode==200){
              this.getOuterNet()
              Message.success('删除成功')
            }
          })
        })
        .catch(() => {});
     
    },
    addProFn(row){
      this.peanut.id = row.id
      this.peanut.hotelname = row.hotelname
      this.peanut.username = row.username
      this.peanut.pwd = row.pwd
      this.peanut.url = row.url
      this.peanutFlow = true
    },
    chage(e){
      this.$forceUpdate()
    },
    btnsQuer(){
      if(this.peanut.hotelname==''){
        Message.error('请输入名称')
        return false
      }
      if(this.peanut.url==''){
        Message.error('请输入花生壳地址')
        return false
      } 
      if(this.peanut.username==''){
        Message.error('请输入花生壳账号')
        return false
      } 
      if(this.peanut.pwd==''){
        Message.error('请输入	花生壳密码')
        return false
      }
      if(this.peanut.id){
        SetOuterNetAnalysis(this.peanut).then(res=>{
          if(res.data.rcode==200){
            Message.success('添加成功')
            this.peanutFlow = false
            this.peanut = {
              token: window.sessionStorage.getItem("Token"),
              username:'',
              hotelname:'',
              addres:'',
              pwd:'',
              id:''
            }
            this.getOuterNet()
            
          }else{
            Message.success(res.data.msg)
          }
        })
      }else{
        OuterNetAnalysisAdd(this.peanut).then(res=>{
          if(res.data.rcode==200){
            Message.success('添加成功')
            this.peanutFlow = false
            this.getOuterNet()
            this.peanut={
              token: window.sessionStorage.getItem("Token"),
              username:'',
              hotelname:'',
              addres:'',
              pwd:'',
              id:''
            }
          }else{
            Message.success(res.data.msg)
          }
        })
      }
    },
    PeanuHandleClose(){
      this.peanutFlow = false
      this.peanut={
        token: window.sessionStorage.getItem("Token"),
        username:'',
        hotelname:'',
        addres:'',
        pwd:'',
        id:''
      }
    },
    addPeanut(){
      this.peanutFlow = true
    },
    tuikuanClose(){
      this.tuikuanvisible = false
    },
    TuiSetFn(){
      this.tuikuanvisible = true;
      this.$nextTick(() => {
        this.$refs.tuikuanDialog.tuiSet();
      });
    },
    mobileHandleClose() {
      this.blacklist = false;
      this.formblack.mobile = ''
      this.formblack.idcard = ''
    },
    addblacklist() {
      this.blacklist = true;
    },
    // 切换tab
    tabFn(i) {
      if(this.typeTab==i){
        return false
      }
      this.typeTab = i;
      this.tableData = []
      if (i == 2) {
        this.getBlack();
      }else if(i==3){
        this.getOuterNet()
      }else if(i==4){
        this.getPayInfo()
      }
    },
    getOuterNet(){
      let data = {
        token: window.sessionStorage.getItem("Token"),
      }
      GetOuterNetAnalysis(data).then(res=>{
        if(res.data.rcode==200){
          this.tableData = res.data.result
        }
      })
    },
    // 添加
    increase() {
      if (this.formblack.mobile == ""&&this.formblack.idcard == "") {
        Message.error("请输入一项");
        return false;
      }
      var phcheck = /^1[3456789]\d{9}$/; // 手机号验证
      var idcheck = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      console.log(this.formblack.mobile,123456)
      if(this.formblack.mobile){
        if (phcheck.test(this.formblack.mobile)) {
        } else {
          Message.error("请输入正确手机号");
          return false;
        }
      }
      if(this.formblack.idcard){
        if (idcheck.test(this.formblack.idcard)) {
          var idCard = this.formblack.idcard
          if (idCard.length == 18) {
            var idCardWi = new Array(
              7,
              9,
              10,
              5,
              8,
              4,
              2,
              1,
              6,
              3,
              7,
              9,
              10,
              5,
              8,
              4,
              2
            ); //将前17位加权因子保存在数组里
            var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
            var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
            for (var i = 0; i < 17; i++) {
              idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }
            var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
            var idCardLast = idCard.substring(17); //得到最后一位身份证号码
            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
              if (idCardLast == "X" || idCardLast == "x") {
              } else {
                Message.error("身份证号码错误！");
                return false;
              }
            } else {
              //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
              if (idCardLast == idCardY[idCardMod]) {
              } else {
                Message.error("身份证号码错误！");
                return false;
              }
            }
          }
        }else{
          Message.error("请输入正确身份证号");
          return false;
        }
      }
      addBlackList(this.formblack).then(res=>{
        if(res.data.rcode==200){
          this.getBlack();
          Message.success('添加成功')
          this.blacklist = false;
          this.formblack.mobile = ''
          this.formblack.idcard = ''
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 导出
    exportList() {
      let data = {
        token: window.sessionStorage.getItem("Token"),
        type: this.data2.type,
        mobile: this.data2.mobile,
        idcard: this.data2.idcard,
      };
      exportBlackList(data).then((res) => {
        if (res.data.rcode == 200) {
          window.location.href = res.data.result;
        }
      });
    },
    // 查询
    query() {
      if (this.data2.type == "") {
        this.$message.error("类型不能为空");
        return false;
      }
      this.data2.total = 0;
      this.data2.page = 1;
      this.getBlack();
    },
    // 删除黑名单
    dete(id) {
      MessageBox("此操作将删除黑名单中该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            token: window.sessionStorage.getItem("Token"),
            id: id,
          };
          deleteBlackList(data).then((res) => {
            if (res.data.rcode == "200") {
              this.getBlack();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    blackListPage(e) {
      this.data2.page = e;
      this.getBlack();
    },
    // 黑名单列表
    getBlack() {
      getBlackList(this.data2).then((res) => {
        if (res.data.status == "ok") {
          this.tableData = res.data.result.data;
          this.data2.total = res.data.result.total;
        }
      });
    },
    setClose() {
      this.information();
      this.getpost();
      this.getMsm();
      this.infovisible = false;
    },
    getMsm() {
      let data = {
        token: window.sessionStorage.getItem("Token"),
      };
      QFSMS(data).then((res) => {
        console.log(res);
        if (res.data.status == "ok") {
          this.num = this.num - res.data.result.length;
        }
      });
    },
    estinClose() {
      this.estintervisible = false;
      this.getpost();
    },
    // 获取基本信息
    getpost() {
      ScenicPortList(this.data).then((res) => {
        if (res.data.status == "ok") {
          this.interface = res.data.result;
        }
      });
    },
    // 基本信息
    information() {
      ScenicMessage(this.data).then((res) => {
        if (res.data.status == "ok") {
          this.infor = res.data.result;
        }
      });
    },
    // 结算设置
    maySetFn() {
      this.maySetvisible = true;
      this.$nextTick(() => {
        this.$refs.maySetDialog.maySet();
      });
    },
    // 添加应用接口
    addInter() {
      this.estintervisible = true;
      this.$nextTick(() => {
        this.$refs.estinterDialog.estinterFn();
      });
    },
    // 应用接口
    interFn(item) {
      this.intervisible = true;
      this.$nextTick(() => {
        this.$refs.interDialog.interFn(item);
      });
    },
    interClose() {
      this.intervisible = false;
    },
    // 微信公众号
    wxOfficalFn() {
      this.wxofficalvisible = true;
      this.$nextTick(() => {
        this.$refs.wxofficalDialog.wxoffical();
      });
    },
    // 去编辑发送
    editSend() {
      if (this.num <= 0) {
        this.$message.error('本月群发次数已用完')
        return false;
      }
      this.editSendvisible = true;
      this.$nextTick(() => {
        this.$refs.editSendDialog.editSend();
      });
    },
    // 群发弹框关闭
    massMsgClose() {
      this.editSendvisible = false;
      this.getMsm();
      this.information();
    },
    // 基本信息设置
    infoSetFn(infor) {
      this.infovisible = true;
      this.$nextTick(() => {
        this.$refs.infoDialog.infoSet(infor);
      });
    },
    // 短信设置
    noteSetFn() {
      this.notevisible = true;
      this.$nextTick(() => {
        this.$refs.noteDialog.noteSet();
      });
    },
    // 短信设置关闭
    ScenicNot() {
      this.notevisible = false;
    },
    // 节日设置
    fivstFn() {
      this.fivstvisible = true;
      this.$nextTick(() => {
        this.$refs.fivstDialog.fivst();
      });
    },
    onPanelChange(value, mode) {
      // eslint-disable-next-line no-console
      console.log(value, mode);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex,
      });
    },

    //日客流量补传
    onUpload(){
      if(!this.supplementaryPassDate){
        Message.error('请选择补传日期')
        return false
      }
      this.uploadLoading = true
      let data = {
        date: this.supplementaryPassDate,
      }
      peopleFlowByDate(data).then(res=>{
        this.uploadLoading = false
        if(res.data.code==200){
          Message.success('补传成功')
        }else{
          Message.error(res.data.msg)
        }
      })
    },

    headerRender({ value, type, onChange, onTypeChange }) {
      const start = 0;
      const end = 12;
      const monthOptions = [];

      const current = value.clone();
      const localeData = value.localeData();
      const months = [];
      for (let i = 0; i < 12; i++) {
        current.month(i);
        months.push(localeData.monthsShort(current));
      }

      for (let index = start; index < end; index++) {
        monthOptions.push(
          <a-select-option class="month-item" key={`${index}`}>
            {months[index]}
          </a-select-option>
        );
      }
      const month = value.month();

      const year = value.year();
      const options = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        options.push(
          <a-select-option key={i} value={i} class="year-item">
            {i}
          </a-select-option>
        );
      }
      return (
        <div style={{ padding: "10px" }}>
          <a-row type="flex" justify="space-between">
            <a-col>
              <a-radio-group
                size="small"
                onChange={(e) => onTypeChange(e.target.value)}
                value={type}
              >
                <a-radio-button value="month">Month</a-radio-button>
                <a-radio-button value="year">Year</a-radio-button>
              </a-radio-group>
            </a-col>
            <a-col>
              <a-select
                size="small"
                dropdownMatchSelectWidth={false}
                class="my-year-select"
                onChange={(newYear) => {
                  const now = value.clone().year(newYear);
                  onChange(now);
                }}
                value={String(year)}
              >
                {options}
              </a-select>
            </a-col>
            <a-col>
              <a-select
                size="small"
                dropdownMatchSelectWidth={false}
                value={String(month)}
                onChange={(selectedMonth) => {
                  const newValue = value.clone();
                  newValue.month(parseInt(selectedMonth, 10));
                  onChange(newValue);
                }}
              >
                {monthOptions}
              </a-select>
            </a-col>
          </a-row>
        </div>
      );
    },
  },
};
</script>

<style lang='less' scoped>
.btns_wx_zfb{
  margin-top: 2rem;
  >div{
    margin-left: 4rem;
    width: 10rem;
    height: 4rem;
    background: #246DEB;
    color: #fff;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    cursor: pointer;
  }
}
.content_box_back{
  background: #fff;
}
.contentBox {
  width: 100%;
  // height: 800px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .conOne {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    // border: 1px solid #000000;
    .conRight {
      margin: 0 20px 20px 0;
      width: 400px;
      // height: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px;
      > div:nth-child(1) {
        height: 58px;
        line-height: 58px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > span:nth-child(1) {
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          color: #000000;
        }
        > span:nth-child(2) {
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 18px;
          color: #666666;
        }
      }
    }
    .conCenter {
      // height: 100%;
      width: 400px;
      margin: 0 20px 20px 0;
      //   border: 1px solid yellow;
      .conCenterTop {
        height: 29.1rem;
        width: 100%;
        padding: 0 20px 10px 20px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 4px;
        > div:nth-child(1) {
          height: 58px;
          line-height: 58px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 25px;
            color: #000000;
          }
          > span:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            color: #666666;
          }
        }
        > div:nth-child(3) {
          height: 30px;
          line-height: 30px;
          margin-bottom: 10px;
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */
            color: #666666;
          }
          > span:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */
            color: #5b91f0;
            margin: 0 5px;
          }
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */
            color: #666666;
          }
        }
        > div:nth-child(4) {
          width: 99%;
          height: 130px;
          padding: 20px;
          box-sizing: border-box;
          background: #f7f7fa;
          border-radius: 4px;
          > div:nth-child(1) {
            margin-bottom: 20px;
            > span:nth-of-type(1) {
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */
              color: #666666;
            }
            > span:nth-of-type(2) {
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #5b91f0;
            }
          }
          > div:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            text-align: justify;

            color: #000000;
          }
        }
      }
      .conCenterBottom {
        height: 18rem;
        width: 100%;
        margin-top: 20px;
        padding: 0 20px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 4px;
        > div:nth-child(1) {
          height: 58px;
          line-height: 58px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            color: #000000;
          }
          > span:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            color: #666666;
          }
        }
        > div:nth-child(3) {
          margin-bottom: 10px;
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
          }
          > span:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #246deb;
            margin: 0 5px;
          }
          > span:nth-child(3) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
          }
        }
        > div:nth-child(4) {
          .el-button {
            width: 99%;
            height: 47px;
            background: #246deb;
            border-radius: 4px;
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */
            border: none;
            color: #ffffff;
          }
        }
      }
    }

    .calendarData {
      margin-bottom: 20px;
      flex: 1;
      background: #ffffff;
      border-radius: 4px;
      padding: 10px 20px;
      box-sizing: border-box;
      // 日历

      > div:nth-child(1) {
        display: flex;
        .dataC {
          /deep/.ant-fullcalendar table {
            height: 100%;
          }
        }
      }
      // 最近节假日
      > div:nth-child(2) {
        > div:nth-child(1) {
          height: 58px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            color: #000000;
          }
          > span:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            color: #666666;
          }
        }
        > div:nth-child(3) {
          display: flex;
          justify-content: space-between;
          align-items: center;
          > div:nth-child(1) {
            width: 48%;
            // height: 70px;
            background: #ffffff;
            border: 1px solid #e5e5ea;
            border-radius: 4px;
            padding: 10px;
            box-sizing: border-box;
          }
          > div:nth-child(2) {
            width: 48%;
            // height: 70px;
            background: #ffffff;
            border: 1px solid #e5e5ea;
            border-radius: 4px;
            padding: 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  .conTwo {
    margin-top: 2rem;
    width: 100%;
    display: flex;
    // > div:nth-child(1) {
    //   width: 24.2%;
    //   height: 100%;
    //   padding: 0 20px;
    //   box-sizing: border-box;
    //   background: #ffffff;
    //   border-radius: 4px;
    //   margin-right: 20px;
    //   > div:nth-child(1) {
    //     height: 58px;
    //     line-height: 58px;
    //     font-family: "PingFang SC";
    //     font-style: normal;
    //     font-weight: 600;
    //     font-size: 18px;
    //     color: #000000;
    //   }
    //   > div:nth-child(3) {
    //     font-family: "PingFang SC";
    //     font-style: normal;
    //     font-weight: 400;
    //     font-size: 14px;
    //     color: #666666;
    //     // margin-bottom: 10px;
    //   }
    //   > div:nth-child(4) {
    //     margin-bottom: 10px;
    //   }
    // }
    .conTwoRight {
      width: 100%;
      height: 100%;
      display: flex;
      > div:nth-child(1) {
        width: 75%;
        // height: 35.5%;
        margin-bottom: 20px;
        background: #ffffff;
        border-radius: 4px;
        padding: 20px;
        box-sizing: border-box;
        > div:nth-child(1) {
          height: 58px;
          line-height: 58px;
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          color: #000000;
        }
        > div:nth-child(3) {
          display: flex;
          justify-content: space-between;
          > div:nth-child(1) {
            .el-button {
              // width: 100px;
              background: #ffffff;
              border: 1px solid #246deb;
              border-radius: 4px;
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              text-align: center;
              color: #246deb;
              margin: 10px 10px 10px 0;
            }
          }
          > div:nth-child(2) {
            .el-button {
              width: 120px;
              background: #246deb;
              border-radius: 4px;
              font-family: "PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              text-align: center;
              color: #ffffff;
              border: none;
            }
          }
        }
      }
      > div:nth-child(2) {
        flex: 1;
        background: #ffffff;
        border-radius: 4px;
        padding: 20px;
        box-sizing: border-box;
        margin-left: 2rem;
        > div:nth-child(1) {
          display: flex;
          justify-content: space-between;
          align-items: center;
          > span:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            color: #000000;
          }
          > span:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            color: #666666;
          }
        }
      }
    }
  }
}
.festival {
  position: relative;
  margin-top: 10px;
  > div:nth-child(1) {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 5px;
  }
  > div:nth-child(2) {
    > span:nth-child(1) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-right: 5px;
    }
    > span:nth-child(2) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-right: 70px;
    }
    > span:nth-child(3) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-right: 5px;
    }
    > span:nth-child(4) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-right: 5px;
    }
  }
  .img {
    position: absolute;
    top: 0px;
    right: 0;
  }
  .btn {
    width: 60px;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    position: absolute;
    top: -1px;
    right: 0;
    // display: none;
    .el-button {
      height: 20px;
      color: #246deb;
    }
    .btnL {
      height: 20px;
      color: #ff4d4f;
      margin-right: 7px;
    }
  }
}

/deep/.ant-fullcalendar {
  height: 220px;
}
// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 10px 0;
}
// 描述列表
/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 2px;
}
/deep/.el-descriptions-item__label {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
/deep/.el-descriptions-item__content {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 13px;
}
.tabCss {
  display: flex;
  margin: 20px 0;
  .active {
    background: #246deb;
    border-radius: 4px;
  }
  span {
    cursor: pointer;
    display: block;
    width: 100px;
    height: 40px;
    line-height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-right: 20px;
  }
}
.searRow {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .searLeft {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 240px;
      margin-bottom: 1rem;
      margin-right: 10px;
    }
    .searLeftSel {
      // margin-bottom: 1rem;
      margin-right: 10px;
    }
    .el-select {
      width: 260px;
      margin-bottom: 1rem;
      margin-right: 10px;
    }
  }
  .el-button {
    margin-bottom: 20px;

    width: 136px;
    background: #246deb;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
  }
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 20px auto 0px;
}
.flexbtnL {
  display: flex;
  justify-content: center;
}
.searRight {
  display: flex;
  align-items: center;
}
.searRight div{
  border-radius: 0.4rem;
  border: 1px solid #246DEB;
  background: #FFF;
  width: 9.3rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2rem;
}
.searRight div img{
  width:1.4rem;
  height: 1.4rem;
  margin-right: 0.8rem;
}
.searRight div span{
  color: #246DEB;
  font-family: OPPOSans;
  font-size: 1.4rem;
}
/deep/ .el-descriptions__table tbody{
  margin-top: 1rem;
  display: block;
}
.add_axios{
  padding-top: 1rem;
}
.muban{
    width: 99%;
    height: 130px;
    padding: 20px;
    box-sizing: border-box;
    background: #f7f7fa;
    border-radius: 4px;
    margin-top: 2rem;
    div{
      span{
        &:nth-child(2){
          color: #5b91f0;
        }
      }
    }
}
.contentBoxs{
  background-color: #FFF;
}
::v-deep  .el-dialog__body{
  border-top: 1px solid #DCDFE6;
  padding:2rem 2.5rem !important;
}
</style>